import React, { Children } from 'react';
import styled from 'styled-components';

interface Props {
	href?: string;
	disabled?: boolean;
	onClick?: () => void;
	children: React.ReactNode
	className?: string;
}

const Wrapper = styled.div`
  width: 100%;
  text-align: center;
  margin: 0.5em 0;
`;

const StyledButton = styled.button``;

export const Button: React.FC<Props> = (props: Props) => {
	// Render a button by default
	const classNames = `button ${props.className || ''}${props.disabled ? ' disabled' : ''}`;

	let button = (
		<StyledButton className={classNames} onClick={props.onClick} disabled={props.disabled}>
			{Children.toArray(props.children)}
		</StyledButton>
	);

	// If the Button has a href prop, we want to render a link
	if (props.href) {
		button = (
			<a href={props.href} className={classNames} onClick={props.onClick}>
				{Children.toArray(props.children)}
			</a>
		);
	}

	return (
		<Wrapper>
			{button}
		</Wrapper>
	);
}
